import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import API_Service, {axiosDefaultConfig} from "../../Services/API_Service";
import {req_module_setting} from "../../Helper/Constants";
import {getSetting} from "../../Helper/Helper";
import CryptoJS from 'crypto-js';

const aesKey = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");
const hmacKey = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");

const decrypt = (encryptedText) => {
	if (!encryptedText) return "";
	try {
		const parts = encryptedText.split(":");
		if (parts.length !== 3) {
			console.error("Invalid encrypted format");
			return "";
		}

		const ivBase64 = parts[0];
		const cipherTextBase64 = parts[1];
		const hmacReceived = parts[2];

		const hmacCalculated = CryptoJS.HmacSHA256(ivBase64 + cipherTextBase64, hmacKey).toString(CryptoJS.enc.Base64);

		if (hmacReceived !== hmacCalculated) {
			console.error("HMAC verification failed");
			return "";
		}

		const iv = CryptoJS.enc.Base64.parse(ivBase64);
		const ciphertext = CryptoJS.enc.Base64.parse(cipherTextBase64);

		const decrypted = CryptoJS.AES.decrypt(
			{ ciphertext: ciphertext },
			aesKey,
			{
				iv: iv,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
			}
		);
		return decrypted.toString(CryptoJS.enc.Utf8);
	} catch (e) {
		console.error("Decryption error", e);
		return "";
	}
};

export default function PowerBIInsight() {
	const [gState] = useContext(AppContext);
	var {translation: language, client} = gState;
	const singleton = PersistantData.getInstance();
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}

	const [key, setKey] = useState("");

	useEffect(() => {
		if (!client) return;
		const fetchPowerBISettings = async () => {
			try {
				const axiosGetConfig = axiosDefaultConfig(client);
				const { data } = await API_Service.get(req_module_setting, axiosGetConfig);
				const { result, extraData } = data;
				if (result === 1) {
					let powerBISettings = getSetting(extraData, 'powerBI', {});
					if (powerBISettings?.key) {
						setKey(decrypt(powerBISettings.key));
					}
				}
			} catch (error) {
				console.error('Failed to fetch PowerBI settings:', error);
			}
		};
		fetchPowerBISettings();
	}, [client]);

	const iFrame = key ? "https://app.powerbi.com/view?r=" + key : "";

	return (
		<div
			style={{
				height: "85vh",
				overflow: "hidden",
				position: "relative"
			}}
		>
			<iframe
				title="powerbi"
				src={iFrame}
				style={{
					width: "100%",
					height: "calc(85vh + 60px)", // 👈 多给高度
					border: "0",
				}}
				allowFullScreen
			/>
		</div>
	);
}
